import { ReportType } from "./enum/report-type.enum";

export interface ICategoryReport {
  id?: string;
  name?: string;
  planPeriodId?: string;
  reportScheduleId?: string;
  reportType?: ReportType;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<ICategoryReport> = {
  IsDeleted: false,
};
